
import { supabase } from '@/integrations/supabase/client';
import { getWebSearchData } from '@/services/webSearchService';
import { getLeadById } from '@/services/leads';
import { CompanyWebSearchResult, getCompanyWebSearchData } from '@/services/companyWebSearchService';
import { getStatusDisplayInfo } from '@/services/leads/leadStatus';
import { getUserCompanyId } from './core';
import { LeadStatus } from '@/types/lead';

interface SenderInfo {
  senderName?: string;
  senderRole?: string;
  senderCompany?: string;
}

export const generateEmailTemplate = async (
  leadId: string, 
  senderInfo?: SenderInfo,
  customPrompt?: string
): Promise<string | null> => {
  try {
    // Get lead data
    const lead = await getLeadById(leadId);
    if (!lead) {
      console.error('Lead not found:', leadId);
      return null;
    }

    // Get lead web search data
    const leadWebSearchData = await getWebSearchData(leadId);

    // Get user's company ID
    const companyId = await getUserCompanyId();
    
    // Get company web search data if company ID exists
    let companyWebSearchData: CompanyWebSearchResult | null = null;
    if (companyId) {
      companyWebSearchData = await getCompanyWebSearchData(companyId);
    }

    // Get lead status info for personalized templates
    const leadStatus = lead.status as LeadStatus || 'new';
    const statusInfo = getStatusDisplayInfo(leadStatus);
    
    // Validate sender info
    const validatedSenderInfo = {
      senderName: senderInfo?.senderName?.trim() || '',
      senderRole: senderInfo?.senderRole?.trim() || '',
      senderCompany: senderInfo?.senderCompany?.trim() || ''
    };
    
    console.log('Generating email template with sender info:', validatedSenderInfo);
    
    // Call edge function to generate the email template
    const { data, error } = await supabase.functions.invoke('generate-template', {
      body: { 
        type: 'email',
        leadData: {
          ...lead,
          status: leadStatus,
          statusLabel: statusInfo.label,
          webSearchData: leadWebSearchData
        },
        companyData: companyWebSearchData,
        templateType: leadStatus || 'default',
        senderInfo: validatedSenderInfo,
        customPrompt: customPrompt || ''
      }
    });

    if (error) {
      console.error('Error generating email template:', error);
      return null;
    }

    return data.template;
  } catch (error) {
    console.error('Error in generateEmailTemplate:', error);
    return null;
  }
};
